module.exports = __webpack_public_path__ + "static/media/paperpile.2a7fbe94.jpg";